/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUserCircle: {
  name: 'user-circle';
  data: string;
} = {
  name: 'user-circle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4a8 8 0 0 0-6.296 12.937A7 7 0 0 1 12 13a7 7 0 0 1 6.296 3.937A8 8 0 0 0 12 4Zm4.757 14.433a1.009 1.009 0 0 1-.041-.1 5.002 5.002 0 0 0-9.432 0 1.004 1.004 0 0 1-.041.1A7.964 7.964 0 0 0 12 20a7.964 7.964 0 0 0 4.757-1.567ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" fill="currentColor"/></svg>`,
};
